import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
//import {  Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select'

export default {
	name: 'bag-details',
	components: {
		BasicSelect,
		Paginate,
		VueElementLoading
	},
	props: [],
	data() {
		return {
			pageCountrule: 0,
			pageCount: 0,
			pageNo: 0,
			bagDetails: [],
			showModal: false,
			showbagShipmentDetailsModal:false,
			isLoadingSearch: false,
			bagNo: '',
			auditLog: [],
			bagShipmentDetails:[]
		}
	},
	computed: {

	},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		},
		BagCategory: function(isparentbag){
			if (isparentbag==true) {
				return "Parent";
			}else if(isparentbag==false){
				return "Child";
			}
		}
	},
	mounted() {

	},
	methods: {
		showShipmentDetails() {
			axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + 'getBagShipmentDetailsByBagNumber?bagNo=' + this.bagNo,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					this.isLoadingSearch = false;
					if (result.data.ResultCode == 100) {
						this.bagShipmentDetails = result.data.ResponseData;
						let totalRows = result.data.ResponseData.length;
						this.showbagShipmentDetailsModal = true;
						if (totalRows < 10) {
							this.pageCountrule = 1
						} else {
							this.pageCountrule = Math.ceil(totalRows / 10);
						}
					} else {
						this.$alertify.error(result.data.ReturnMessage);
						this.bagShipmentDetails = [];
					}
				}, error => {
					console.error(error)
				})
		},
		closebagShipmentDetailsModal(){
			this.showbagShipmentDetailsModal = false;
			$(document.body).removeClass("modal-open");
			$(".modal-backdrop").remove();
		},
		getBagDetailsByBagNo() {
			if (this.bagNo == '' || this.bagNo == undefined) {
				return false;
			}
			this.isLoadingSearch = true;
			axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + 'getBagDetailsByBagNo?bagno=' + this.bagNo,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					this.isLoadingSearch = false;
					if (result.data.ResultCode == 100) {
						this.bagDetails = result.data.ResponseData;
						//  this.$alertify.success(result.data.ReturnMessage);
						let totalRows = result.data.ResponseData.length
						if (totalRows < 10) {
							this.pageCountrule = 1
						} else {
							this.pageCountrule = Math.ceil(totalRows / 10);
						}
					} else {
						this.$alertify.error(result.data.ReturnMessage);
						this.bagDetails = [];
					}
				}, error => {
					console.error(error)
				})
		},
		showModalOnClick(bagDetails) {
			this.auditLog = bagDetails.AuditLog
			this.showModal = true
		},
		closeModal() {
			this.showModal = false;
			$(document.body).removeClass("modal-open");
			$(".modal-backdrop").remove();
		},
		onSubmitSearch: function() {
			var self = this
			this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				}
				// this.$alertify.success("your message");
			}).catch(() => {
				console.log('errors exist')
				//this.$alertify.error("your message")
			});
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/BagDetails/BagDetails.js